<template>
  <div style="text-align: justify">
    <a-tabs>
      <a-tab-pane key="1">
        <span slot="tab"> Tool I . PGSEA </span>
        <div style="background-color: white; padding: 20px 20px">
          <span style="font-size: 20px; font-weight: bolder"
            >PerturbDB has generated reference file from Perturb-Seq and Bulk
            perturbation RNA-Seq data after quality control. Those gene sets
            were splited into two groups: up-regulated gene sets and
            down-regulated gene sets.
            <!-- ORA was
            performed with the input data and those 8361 gene sets by using
            enricher function from clusterProfiler. -->
          </span>
          <div style="margin-left: 15px; font-size: 18px">
            1. PerturbDB provides a range of reference files for enrichment
            analysis. Initially, users have the flexibility to select from
            various background files and enrichment methods to perform PGSEA
            analysis effectively.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/GPEA0.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            2. Simply copy and paste your list of genes or upload a file
            (download our demo file to test the tool). Then, click the "Submit"
            button. The analysis usually completes within 3-5 minutes, and the
            enrichment results will be displayed at the bottom of the webpage.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/GPEA1.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            3. In ORA mode, the results are presented as a bubble plot
            displaying the top 20 enrichment analysis outcomes. Additionally,
            PerturbDB provides a comprehensive display of all enriched gene set
            results, which users can query and download.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/PGSEA3.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            4. In GSEA mode, PerturbDB provides a list of enrichment analysis
            results. Users can generate a visual representation by clicking on
            the last column of the list to create a chart of these results.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/GPEA4.png"
            />
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/PGSEA5.png"
            />
          </div>
          <span style="font-size: 20px; font-weight: bolder"
            >We hope PGSEA (Perturbation-induced Gene set Enrichment Analysis)
            can assist users in identifying genes with similar functions to
            their gene of interest using their own bulk or single-cell
            Peturb-seq datasets, as well as potential upstream regulators
            associated with their gene sets.</span
          >
        </div>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab"> Tool II . DrawaCorHeatmap </span>
        <div style="background-color: white; padding: 20px 20px">
          <span style="font-size: 20px; font-weight: bolder"
            >We also provide a useful tool for users to explore the similarity
            of perturbed gene cell population.</span
          >
          <div style="margin-left: 15px; font-size: 18px">
            1. Here, we illustrate the usage of this tool with the Integrator
            complex gene family as a case study. Simply enter "INTS" in the top
            left corner to discover all the associated perturbed genes.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster7.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            2. In this tool, users can set the dimensions for the width and
            height of the output PDF.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster7.5.png"
            />
          </div>
          <div style="margin-left: 15px; font-size: 18px">
            3. After click the <a-button type="primary">Plot</a-button> button,
            the PerturbDB will display a popup window and start generating the
            heatmap. A PDF file will be available within approximately 2
            minutes. We can observe that the Integrator complex forms three
            subcomplexs, with
            <a
              href="https://www.genecards.org/cgi-bin/carddisp.pl?gene=INTS15"
              target="_blank"
              style="color: blue"
              >INTS15</a
            >
            being the most recently discovered and validated member of the
            Integrator complex family.
          </div>
          <div style="text-align: center">
            <img
              width="60%"
              height="60%"
              src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/1cluster8.png"
            />
          </div>
          <span style="font-size: 25px; font-weight: bolder"
            >We hope you enjoy this tool and make interesting discoveries.</span
          >
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
